import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const RoutingActions = createActionGroup({
	source: 'Routing',
	events: {
		'Add Current Route': props<{ currentRoute }>(),
		'Reset Current Route': emptyProps(),
	},
});
